// registerModule('form-input');

export const FormInput = {
    /**
     * Shows and optionally sets the error message of a given input element. Shows the built-in validation message,
     * otherwise the given text, otherwise the default error message.
     * @param {HTMLElement} element
     * @param {string} [text]
     */
    updateError: (element, text) => {
        const parent = FormInput.getParent(element);

        // In rare cases a parent is not defined.
        if (parent) {
            const label = parent.querySelector(':scope > .support-text-container > .input-support-label') || parent.querySelector('.input-label');

            // parent.classList.add('error');
            if (label) {
                label.classList.add('error');
                label.innerHTML = FormInput.getValidationError(element) || text || label.dataset.defaultMessage || '';
            }
        }
    },

    /**
     * Clears out any existing validation / error messages from an input element.
     * @param {HTMLElement} element
     */
    resetError: element => {
        const parent = FormInput.getParent(element);

        // In rare cases a parent is not defined.
        if (parent) {
            parent.classList.remove('error');

            const label = parent.querySelector(':scope > .support-text-container > .input-support-label') || parent.querySelector('.input-label');
            if (label) {
                label.classList.remove('error');

                label.innerHTML = label.dataset.defaultMessage || '';
            }
        }
    },

    /**
     * Returns a browser-generated validation error message (if an error would exist)
     * @param {HTMLInputElement} input
     * @return {null|string}
     */
    getValidationError: input => {
        // Retrieve a validation message even for hidden inputs (which do not validate on their own)
        if (input.type === 'hidden') {
            input = input.cloneNode();
            input.type = 'text';
        }

        return input.validationMessage || input.dataset.customValidationMessage;
    },

    /**
     * Gets the parent (or container) element for all inputs.
     * @param {HTMLElement} element
     * @return {HTMLDivElement|null}
     */
    getParent: element => element.closest('.input-parent') || element.closest('.select-container'),

    /**
     * Handles key-value pair for the Errors coming from PHP into something JS can use.
     * @param {{[key: string]: string[]|string}} errors
     */
    handleErrors: errors => {
        for (let name in errors) {
            FormInput.updateError(
                document.querySelector(`input[name="${name.replace(/\.(\w+)/g, '[$1]')}"]`),
                Array.isArray(errors[name]) ? errors[name][0] : errors[name]
            );
        }
    },

    /**
     * Dispatches the given event type on the given target, which can bubble.
     * @param {HTMLElement} target
     * @param {string} event
     * @returns {boolean}
     */
    dispatch: (target, event) =>
        target.dispatchEvent(new Event(event, { bubbles: true })),
}

onLoad(() => {
    document.body
        .on('submit', 'form', e => {
            // Process certain input types to properly save their properties
            e.currentTarget.querySelectorAll('input.price-input').forEach(input => {
                input.value = Math.round(input.value * 100);
            });
        })
        .on('change', '.js-toggle-input-disabled', e => {
            let target = e.currentTarget.dataset.disableTarget;
            if (target) {
                const value = e.currentTarget.value;
                document.querySelectorAll(target)
                    .forEach(item => {
                        if (value === (item.dataset.disableCondition || '1')) {
                            if (item.classList.contains('text-input')) {
                                item.disabled = true;
                                item.closest('.input-parent').classList.add('disabled');
                            } else {
                                // hide
                                item.style.display = 'none';
                            }
                        } else {
                            if (item.classList.contains('text-input')) {
                                item.disabled = false;
                                item.closest('.input-parent').classList.remove('disabled');
                            } else {
                                // show
                                item.style.display = '';
                            }
                        }
                    });
            }
        })
    ;
});

// Cards
onLoad(() => {
    function handler(e) {
        if (e.target.nodeName === 'A' || e.type === 'mousedown' && (e.which !== 2 || e.buttons !== 4)) {
            // Yes, that's e.target, not e.currentTarget. We need to know what the user REALLY clicked on, not just what the filter wants.
            return;
        }

        const action = e.currentTarget.dataset.action;

        // Otherwise, handle the click as if it was an anchor click.
        if (action) {
            // Action to be called
            window[action].call(this, e);
        }
    }

    document.body
        .on('click', '.card.with-action', handler)
        .on('mousedown', '.card.with-action', handler)
    ;
});
